export default "/_next/static/chunks/fonts/Channel4Chadwick-Bold-663b7f861a8c3001f8d6276a596169f4.woff";